import { requiredFieldValidation } from '../../../../app/validation/validation';

export const validationRules = {
  message: {
    required: requiredFieldValidation,
  },
};
